export default "__VITE_ASSET__C$Rsag9b__"